import { Link } from "react-router-dom";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

function AdminDashboard() {
  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      <Header />
      <main className="flex-grow flex justify-center items-center p-6">
        <div className="bg-white shadow-md rounded-lg p-8 max-w-lg w-full text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">
            Admin Actions
          </h2>
          <div className="space-y-4">
            <Link
              to="/admin/user"
              className="block w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition"
            >
              Manage Users
            </Link>
            <Link
              to="/admin/location_head"
              className="block w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition"
            >
              Location Head
            </Link>
            <Link
              to="/admin/project_head"
              className="block w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition"
            >
              Project Head
            </Link>
            <Link
              to="/admin/store_officer"
              className="block w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition"
            >
              Store Officer
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default AdminDashboard;
